import { render, staticRenderFns } from "./FormFcontinue.vue?vue&type=template&id=22452f13&"
import script from "./FormFcontinue.vue?vue&type=script&lang=js&"
export * from "./FormFcontinue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports